/**
 * Libellés FR de la console « Diffusions » (types, réseaux, statuts).
 */

import type { DiffusionPlatform, DiffusionStatus, DiffusionType } from './types';

export const DIFFUSION_TYPE_LABELS: Record<DiffusionType, string> = {
  challenge: 'Défi',
  exercise_replay: 'Replay exercice',
  playlist: 'Clip playlist',
  exercise_video: 'Vidéo exercice',
  blog: 'Article blog',
};

export const DIFFUSION_PLATFORM_LABELS: Record<DiffusionPlatform, string> = {
  youtube: 'YouTube',
  tiktok: 'TikTok',
  instagram_reels: 'Instagram Reels',
  facebook_reels: 'Facebook Reels',
  linkedin: 'LinkedIn',
  facebook: 'Facebook',
  instagram: 'Instagram',
};

export const DIFFUSION_STATUS_LABELS: Record<DiffusionStatus, string> = {
  draft: 'Brouillon',
  scheduled: 'Programmé',
  publishing: 'Publication…',
  published: 'Publié',
  failed: 'Échec',
};
